import { Icon } from "@simplybusiness/mobius";
import { circleCheck } from "@simplybusiness/icons";
import classNames from "classnames/dedupe";
import type { CyberInsuranceInfoData } from "./cyberInsuranceData";
import "./CyberInsuranceInfo.css";

export type CyberInsuranceInfoProps = {
  data: CyberInsuranceInfoData;
  className?: string;
};

export const CyberInsuranceInfo = ({
  data,
  className,
}: CyberInsuranceInfoProps) => {
  const classes = classNames(
    "mobius",
    "mobius-cyber-insurance-info",
    className,
  );

  return (
    <div
      className={classes}
      data-testid="mobius-cyber-insurance-info"
      role="region"
      aria-label={data.title}
    >
      <div className="mobius-cyber-insurance-info__summary">
        <h2 className="mobius-cyber-insurance-info__title">{data.title}</h2>
        <p className="mobius-cyber-insurance-info__description">
          {data.description}
        </p>
      </div>
      <div className="mobius-cyber-insurance-info__coverage">
        <h3 className="mobius-cyber-insurance-info__coverage-heading">
          {data.coverageHeading}
        </h3>
        <ul
          className="mobius-cyber-insurance-info__coverage-list"
          aria-label={data.coverageHeading}
        >
          {data.coverageItems.map(item => (
            <li
              key={item}
              className="mobius-cyber-insurance-info__coverage-item"
            >
              <span className="mobius-cyber-insurance-info__coverage-text">
                {item}
              </span>
              <Icon
                icon={circleCheck}
                size="md"
                color="var(--color-valid)"
                aria-hidden="true"
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

CyberInsuranceInfo.displayName = "CyberInsuranceInfo";
